/**
 * Custom JavaScript – vanilla version (no jQuery required)
 */

document.addEventListener('DOMContentLoaded', function () {
  console.log('custom.js loaded');

  /**
   * SHOW MORE / SHOW LESS in collection sidebar filters
   * (replaces the old jQuery version)
   */
  const filterContents = document.querySelectorAll(
    '.collection-filters-form .Collapsible .Collapsible__Content'
  );

  filterContents.forEach((content) => {
    const items = Array.from(content.querySelectorAll('.Linklist__Item'));
    if (items.length <= 3) return;

    const visibleItems = items.slice(0, 3);
    const hiddenItems = items.slice(3);

    const mainHtml = visibleItems
      .map((li) => `<li class="Linklist__Item">${li.innerHTML}</li>`)
      .join('');

    const hiddenHtml = hiddenItems
      .map((li) => `<li class="Linklist__Item">${li.innerHTML}</li>`)
      .join('');

    content.innerHTML = `
      ${mainHtml}
      <a href="#" class="show-more">Show More</a>
      <div class="toggle" style="display:none">
        ${hiddenHtml}
        <a href="#" class="show-less">Show Less</a>
      </div>
    `;
  });

  // Delegate clicks for Show More / Show Less
  document.addEventListener('click', function (event) {
    const target = event.target;

    // Show more
    if (target.matches('.show-more')) {
      event.preventDefault();
      const collapsible = target.closest('.Collapsible');
      if (!collapsible) return;

      const toggle = collapsible.querySelector('.toggle');
      if (toggle) {
        toggle.style.display = 'block';
      }
      target.style.display = 'none';
    }

    // Show less
    if (target.matches('.show-less')) {
      event.preventDefault();
      const collapsible = target.closest('.Collapsible');
      if (!collapsible) return;

      const toggle = collapsible.querySelector('.toggle');
      const showMore = collapsible.querySelector('.show-more');

      if (toggle) toggle.style.display = 'none';
      if (showMore) showMore.style.display = 'inline';

      // Smooth scroll back up to the filter block
      const rect = collapsible.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      window.scrollTo({
        top: scrollTop + rect.top - 100,
        behavior: 'smooth',
      });
    }
  });

  /**
   * INQUIRE ABOUT – accordion toggle
   */
  const accordions = document.getElementsByClassName('accordion1');

  Array.prototype.forEach.call(accordions, function (button) {
    button.addEventListener('click', function () {
      this.classList.toggle('active1');
      const panel = this.nextElementSibling;

      if (!panel) return;

      if (panel.style.display === 'block') {
        panel.style.display = 'none';
      } else {
        panel.style.display = 'block';
      }
    });
  });
});


